//stage22AudioController.js
export function createStage22AudioController({
  paper,
  STAGE22_AUDIO,
  BOOK_AUDIO,
}) {
  const amb = paper.querySelector('.audio-22-amb');
  const book = paper.querySelector('.audio-22-book');

  function toAbsUrl(url) {
    try {
      return new URL(url, window.location.href).href;
    } catch {
      return url || '';
    }
  }

  function setSrc(audioEl, src, { loop = true } = {}) {
    if (!audioEl || !src) return;

    const source = audioEl.querySelector('source');
    const current = toAbsUrl(
      source?.src || audioEl.currentSrc || audioEl.src || '',
    );
    const next = toAbsUrl(src);

    if (current !== next) {
      if (source) source.src = src;
      else audioEl.src = src;
      audioEl.loop = loop;
      audioEl.load();
    } else {
      audioEl.loop = loop;
    }
  }

  function play(el) {
    el?.play?.().catch(() => {});
  }

  function pause(el) {
    el?.pause?.();
  }

  function stop(el) {
    if (!el) return;
    el.pause();
    el.currentTime = 0;
  }

  setSrc(amb, STAGE22_AUDIO, { loop: true });

  function onSelectBook(bookIndex) {
    const src = BOOK_AUDIO?.[String(bookIndex)] || BOOK_AUDIO?.[bookIndex];
    if (!src) return;

    pause(amb);
    setSrc(book, src, { loop: true });
    play(book);
  }

  function onCloseViewer() {
    stop(book);
    if (paper.classList.contains('active')) {
      play(amb);
    }
  }

  function onActiveChange(isActive) {
    if (!amb || !book) return;

    if (isActive) {
      if (book.paused) play(amb);
    } else {
      pause(amb);
      pause(book);
    }
  }

  function destroy() {
    stop(book);
    stop(amb);
  }

  return {
    onSelectBook,
    onCloseViewer,
    onActiveChange,
    destroy,
  };
}
